/**
 * Simple logger utility that wraps console methods
 * Allows centralized control over logging behavior
 */
class Logger {
  private enabled: boolean;

  constructor(enabled = false) {
    this.enabled = enabled;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  log(...args: unknown[]): void {
    if (this.enabled) {
      console.log(...args);
    }
  }

  error(...args: unknown[]): void {
    // Error logging is allowed in logger utility
    if (this.enabled) {
      console.error(...args);
    }
  }

  warn(...args: unknown[]): void {
    // Warning logging is allowed in logger utility
    if (this.enabled) {
      console.warn(...args);
    }
  }

  group(label: string): void {
    if (this.enabled) {
      console.group(label);
    }
  }

  groupEnd(): void {
    if (this.enabled) {
      console.groupEnd();
    }
  }
}

// Export a singleton instance
export const logger = new Logger();
